import type { AnnotationSide, FileDiffMetadata } from '@pierre/diffs';

/**
 * Expanded-context lines aren't part of the diff hunk, so GitHub's review
 * comment API rejects comments on them with a 422. The diff renderer marks
 * them with `data-line-type="context-expanded"`.
 */
export const ADD_COMMENT_BUTTON_CSS = `
[data-gutter-utility-slot] {
  right: 0 !important;
  left: unset !important;
  justify-content: flex-end !important;
  transform: translateX(100%);
  margin-top: 1px !important;
  z-index: 5;
}
[data-utility-button] {
  background-color: #27272a !important;
  color: #e4e4e7 !important;
  fill: currentColor !important;
  box-sizing: border-box !important;
  width: 1lh !important;
  height: 1lh !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 1px solid #a1a1aa !important;
}
[data-utility-button]:hover {
  background-color: #3f3f46 !important;
}
[data-line] {
  padding-inline-start: calc(1ch + 1lh) !important;
}
[data-column-number]:has(+ [data-gutter-buffer="annotation"]) [data-gutter-utility-slot] {
  display: none !important;
}
[data-line-type="context-expanded"] [data-gutter-utility-slot] {
  display: none !important;
}
[data-interactive-lines] [data-line][data-line-type="context-expanded"] {
  cursor: default !important;
}
/* A click on an expanded line's number would select that line, and a selection moves the file's draft to it. */
[data-column-number][data-line-type="context-expanded"] {
  pointer-events: none !important;
}`;

/** Expanded-context lines are exactly the lines outside every hunk on their side. */
export function isLineInDiffHunks(
  fileDiff: FileDiffMetadata | null | undefined,
  side: AnnotationSide,
  lineNumber: number,
): boolean {
  if (!fileDiff) {
    // Fail open: PatchDiff keeps its parsed hunks and, with no file loader, shows only those lines.
    return true;
  }

  return fileDiff.hunks.some((hunk) => {
    const start = side === 'deletions' ? hunk.deletionStart : hunk.additionStart;
    const count = side === 'deletions' ? hunk.deletionCount : hunk.additionCount;
    return lineNumber >= start && lineNumber < start + count;
  });
}
